/*
 * <localization-switcher>
 *
 * The markup is already a working control without this file: a native <details>
 * holding real localization <form>s, so a country link is a plain navigation and
 * the forms submit on their own. This element only upgrades a link click into a
 * form submit, which is what actually sets the country/locale cookie rather than
 * merely visiting a localised path.
 *
 * Links marked data-external="true" point at a different shop entirely and are
 * left alone.
 */
if (!customElements.get('localization-switcher')) {
  class LocalizationSwitcher extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');

      this.onToggle = () => {
        if (this.summary) this.summary.setAttribute('aria-expanded', this.details.open ? 'true' : 'false');
      };
      if (this.details) this.details.addEventListener('toggle', this.onToggle);

      this.onDocumentClick = (event) => {
        if (!this.details || !this.details.open) return;
        if (this.contains(event.target)) return;
        this.details.open = false;
      };
      document.addEventListener('click', this.onDocumentClick);

      this.onKeydown = (event) => {
        if (event.key !== 'Escape' || !this.details || !this.details.open) return;
        this.details.open = false;
        if (this.summary) this.summary.focus();
      };
      this.addEventListener('keydown', this.onKeydown);

      this.querySelectorAll('.disclosure__item a').forEach((link) => {
        link.addEventListener('click', (event) => this.select(event, link));
      });
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
      if (this.details) this.details.removeEventListener('toggle', this.onToggle);
      this.removeEventListener('keydown', this.onKeydown);
    }

    select(event, link) {
      if (link.dataset.external === 'true') return;

      const form = link.closest('form');
      if (!form) return;
      event.preventDefault();

      const country = form.querySelector('input[name="country_code"]');
      const locale = form.querySelector('input[name="locale_code"]');

      if (link.dataset.isLanguage === 'true') {
        if (locale) locale.value = link.dataset.value;
      } else if (country) {
        country.value = link.dataset.value;
      }

      /* Reopen the drawer after the reload, so switching country from inside the
       * mobile menu does not dump the visitor back on a closed menu. */
      const drawer = document.getElementById('Details-menu-drawer-container');
      if (drawer && drawer.hasAttribute('open')) {
        try {
          sessionStorage.setItem('menuWasOpen', 'true');
        } catch (error) {
          /* Private mode: the drawer simply will not reopen. */
        }
      }

      /* Strip any locale prefix already on the return path, or the new locale is
       * appended to the old one and the visitor lands on /en-nl/de-de/... */
      const returnTo = form.querySelector('input[name="return_to"]');
      if (returnTo) {
        let path = returnTo.value;
        while (/^\/[a-z]{2}(-[a-z]{2})?(\/|$)/i.test(path)) {
          path = path.replace(/^\/[a-z]{2}(-[a-z]{2})?(\/|$)/i, '/');
        }
        returnTo.value = path;
      }

      form.submit();
    }
  }
  customElements.define('localization-switcher', LocalizationSwitcher);
}

